import { render, staticRenderFns } from "./RefundDetail.vue?vue&type=template&id=453e9c6a&scoped=true"
import script from "./RefundDetail.vue?vue&type=script&lang=js"
export * from "./RefundDetail.vue?vue&type=script&lang=js"
import style0 from "./RefundDetail.vue?vue&type=style&index=0&id=453e9c6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453e9c6a",
  null
  
)

export default component.exports